import * as React from 'react';

function SearchIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={15} height={15} fill="none" {...props}>
      <path
        d="M10.063 6.438c0-1.56-.848-2.981-2.188-3.774a4.32 4.32 0 00-4.375 0 4.341 4.341 0 00-2.188 3.773c0 1.586.82 3.008 2.188 3.801a4.32 4.32 0 004.375 0c1.34-.793 2.188-2.215 2.188-3.8zm-.848 4.484a5.73 5.73 0 01-3.527 1.203A5.683 5.683 0 010 6.437C0 3.32 2.543.75 5.688.75c3.117 0 5.687 2.57 5.687 5.688 0 1.34-.465 2.57-1.23 3.554l3.664 3.637c.246.273.246.684 0 .93-.274.273-.684.273-.93 0l-3.664-3.637z"
        fill="#878787"
      />
    </svg>
  );
}

const MemoSearchIcon = React.memo(SearchIcon);
export default MemoSearchIcon;
